import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class CourseUnitRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    // return get(this, "store").find("course", params.course_id)
    //   .then(course => {
    //     get(this, "store")
    //       .find("planbook", course.relationships.planbook.data.id)
    //       .then(planbook => {
    //         get(this, "store")
    //           .find("rotationCalendar", planbook.relationships.rotationCalendar.data.id)
    //           .then(rotationCalendar => {
    //             return {courseId: params.course_id}
    //           })
    //       })
    //     })
    //
    //   //   let coursePromises = _.map(planbook.relationships.courses.data, datum => get(this, "store").find("course", datum.id))
    //   //   return Ember.RSVP.all(coursePromises)
    //   // })
    // //   .then(_all => {
    // //     return {planbookId: params.planbook_id}
    // //   })
    // // // return
    // //
    // return {courseId: params.course_id}
    return get(this, "store")
      .find("course", params.course_id)
      .then((course) => get(this, "store").find("planbook", course.relationships.planbook.data.id))
      .then((planbook) =>
        get(this, "store").find("rotationCalendar", planbook.relationships.rotationCalendar.data.id)
      )
      .then((rotationCalendar) => {
        return { courseId: params.course_id }
      })
  }
}
